export default function getQFromBandwidthOctaves(bandwidth: number) {
  return Math.sqrt(Math.pow(2, bandwidth)) / (Math.pow(2, bandwidth) - 1);
}
